import React from "react";
import "./About.css";
import ProfilePicture from '../../assets/images/pixeltrue-support.svg'
import PlainHeader from "../../components/PlainHeader/PlainHeader";
import twitter from '../../assets/images/twitterBlack.svg'
import github from '../../assets/images/githubBlack.svg'
import linkedin from '../../assets/images/linkedinBlack.svg'

const About = () => {
    return (
        <div>
            <PlainHeader />
            <div className="homeContainer bd-grid">
                <div className="homeImg aboutImg" style={{ visibility: "visible" }}>
                    <img
                        // style={{ objectFit: "cover" }}
                        className="profilePicture"
                        alt="Developer"
                        src={ProfilePicture}
                        width="300px"
                        height="213px"
                    />
                </div>
                <div className="homeData">
                    <p
                        className="homeTitle"
                        style={{ visibility: "visible", fontSize: "50px" }}
                    >
                        Jayanth Saikiran
                    </p>

                    <p className="aboutDescription" style={{ visibility: "visible" }}>
                        I’m a Web Developer with a passion for participate in every stage <br />
                        of digital product, from discovery to delivery. Helping to focus <br />
                        the business goals on users.  <br />
                    </p>

                    <div className="social-media-icons-about">
                        <img src={linkedin} alt="linkedin" onClick={() => window.open("https://www.linkedin.com/in/jayanthsaikiran/", "_blank")}/>
                        <img src={github} alt="github" onClick={() => window.open("https://github.com/jayanthsaikiran", "_blank")}/>
                        <img src={twitter} alt="twitter" onClick={() => window.open("https://twitter.com/jayanthsaikiran", "_blank")} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
